import { useDispatch } from "react-redux";
import { useBuckets } from "./Buckets/useBuckets";
import { usePacks } from "./Packs/usePacks";
import { useCartHelpers } from "./useCartHelpers";
import {
  eventsState,
  selectEventsSelected,
} from "@/global/store/data/purchaseSeats/events";
import { useAppStore } from "@/global/store";
import { calcDefaultPurchaseSeatTab } from "./utils.purchaseSeats";
import { useTeamConfig } from "@/global/hooks/useTeamConfig";
import { useRouterExtended } from "@/global/hooks/useRouterExtended";
import { routes } from "@/global/routes";

export function useCartNavigationHelper() {
  const teamConfig = useTeamConfig();
  const { teamSchema, defaultRoute } = teamConfig;
  const router = useRouterExtended();
  const dispatch = useDispatch();
  const { isBucketsEnabled } = useBuckets();
  const { isPacksEnabled } = usePacks();
  const selectedEvents = useAppStore(selectEventsSelected);

  // basic function for switching purchase seat tab
  const switchPurchaseSeatTab = async (purchaseSeatTab: string) => {
    await router.replaceShallow({ query: { teamSchema, purchaseSeatTab } });
    window.scrollTo({ top: 0 });
  };

  const backToFindGames = async () => {
    // cleaning event selection to avoid conflicts
    if (isBucketsEnabled || isPacksEnabled) {
      dispatch(
        eventsState.actions.removeEventMulti(
          selectedEvents.map((event) => event.eventCode)
        )
      );
    }
    const defaultTab = calcDefaultPurchaseSeatTab(teamConfig);
    await switchPurchaseSeatTab(defaultTab);
  };

  const navigateToDefaultPage = async () => {
    await router.pushSchema(defaultRoute || routes.purchaseSeats);
  };

  return {
    backToFindGames,
    navigateToDefaultPage,
  };
}
